export default __webpack_public_path__ + "static/media/Logo-Dark.736e0965.svg";